module.exports = __webpack_public_path__ + "images/company_profile/icon03-c58beee24c163b91d4f93bf5ee6404a1.png";